$(() => {
    const serviceStatusPlaceholder = $(".js-service-status-messages");

    if (!serviceStatusPlaceholder.length) return;

    const updateInterval = 60 * 100 * 10; // Update every 10 minutes

    getServiceMessages(serviceStatusPlaceholder);
    window.setInterval(
        function () {
            getServiceMessages(serviceStatusPlaceholder);
        }, updateInterval);
});

function getServiceMessages(serviceStatusPlaceholder) {
    $.ajax({
        url: "/api/intranet-service-status/",
        success: function (data) {
            if (!!data) serviceStatusPlaceholder.html(data);
        },
        error: function (err) {
            console.error(err);
        }
    });
}
